import axios from "axios";
import { getAxiosConfigWithToken } from "../../../helpers/functions_helper"
import * as url from "../../../helpers/url_helper"

const SERVER_URL = process.env.REACT_APP_SERVER_URL;

class Service {

    async get(data: any) {
        const response = await axios
            .get(`${SERVER_URL}${url.IMMIGRATION.GET}/${data.id}/${data.immigration_id}`,
                {
                    headers: getAxiosConfigWithToken()
                }
            ).then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error;
            });
        return response;
    }

    async create(data: any) {
        const response = await axios
            .post(`${SERVER_URL}${url.IMMIGRATION.CREATE}`, data,
                {
                    headers: getAxiosConfigWithToken()
                }
            ).then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error;
            });
        return response;
    }

    async update(data: any) {
        const response = await axios
            .put(`${SERVER_URL}${url.IMMIGRATION.UPDATE}`, data,
                {
                    headers: getAxiosConfigWithToken()
                }
            ).then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error;
            });
        return response;
    }

    async createApplication(data: any) {
        const response = await axios
            .post(`${SERVER_URL}${url.IMMIGRATION.CREATE_APPLICATION}`, data,
                {
                    headers: getAxiosConfigWithToken()
                }
            ).then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error;
            });
        return response;
    }

    async updateApplication(data: any) {
        const response = await axios
            .put(`${SERVER_URL}${url.IMMIGRATION.UPDATE_APPLICATION}`, data,
                {
                    headers: getAxiosConfigWithToken()
                }
            ).then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error;
            });
        return response;
    }

    async getAll(data: any) {
        const response = await axios
            .post(SERVER_URL + url.IMMIGRATION.GET_ALL, data,
                {
                    headers: getAxiosConfigWithToken()
                }
            ).then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error;
            });
        return response;
    }
}
export default new Service();